module.exports = __webpack_public_path__ + "img/ATTRACTION.75e360c7.jpg";